const facultyReducer = (draft, action) => {
    switch (action.type) {
        case "setDialogTitle":
            draft.dialogTitle = action.value;
            return
        case "setClassesOpenDialog":
            draft.classesOpenDialog = action.value;
            return
        case "setClassesClassID":
            draft.classesClassID = action.value;
            return
        case "setClassesClassroom":
            draft.classesClassroom = action.data;
            return
        default:
            return
    }
};

export default facultyReducer;